import { FC, SVGAttributes } from 'react';

const CarTool: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M45 40H52.5V47.5C52.5 48.8807 51.3807 50 50 50H47.5C46.1193 50 45 48.8807 45 47.5V40Z" fill="#383E43" />
      <path d="M7.5 40H15V47.5C15 48.8807 13.8807 50 12.5 50H10C8.61929 50 7.5 48.8807 7.5 47.5V40Z" fill="#383E43" />
      <path
        d="M18.4039 10C17.0701 10 15.8368 10.7084 15.1647 11.8605L8.52166 23.2486C7.85256 24.3956 7.5 25.6997 7.5 27.0276L7.5 40C7.5 42.7615 9.73858 45 12.5 45H47.5C50.2614 45 52.5 42.7615 52.5 40V27.0276C52.5 25.6997 52.1474 24.3956 51.4783 23.2486L44.8353 11.8605C44.1632 10.7084 42.9299 10 41.5961 10L18.4039 10Z"
        fill="#8A9DFF"
      />
      <path
        d="M40.4462 19.6776L36.0599 24.0504L33.4321 21.4318L37.8184 17.0606C35.3724 15.8706 31.9414 15.8658 29.9102 17.891C27.9997 19.795 27.7611 22.7922 28.691 25.1501L18.9409 34.8228C18.8804 34.8831 18.8324 34.9548 18.7996 35.0337C18.7669 35.1126 18.75 35.1972 18.75 35.2826C18.75 35.368 18.7669 35.4526 18.7996 35.5315C18.8324 35.6104 18.8804 35.6821 18.9409 35.7424L21.7683 38.5611C21.8286 38.6216 21.9003 38.6696 21.9792 38.7024C22.0581 38.7352 22.1426 38.752 22.2281 38.752C22.3135 38.752 22.3981 38.7352 22.477 38.7024C22.5559 38.6696 22.6276 38.6216 22.6879 38.5611L32.4244 28.7975C34.759 29.6743 37.7254 29.4271 39.6046 27.5534C41.633 25.5277 41.6287 22.1258 40.4462 19.6776Z"
        fill="white"
      />
    </svg>
  );
};

export default CarTool;
